module.exports = __webpack_public_path__ + "fonts/PFDinTextCondPro-Bold.9ae3709d.ttf";